import * as React from 'react';
import {SvgXml} from 'react-native-svg';

interface IProps {
  width?: number;
  strokeColor?: string;
  fillColor?: string;
}

export default (props: IProps) => {
  const {width} = props;

  const xml = `
  <?xml version="1.0" encoding="UTF-8"?>
  <svg width="${width ?? '36'}" height="${
    width ?? '35'
  }" viewBox="0 0 36 35" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M35.1866 17.5C35.1866 27.165 27.4217 35 17.8433 35C8.26485 35 0.5 27.165 0.5 17.5C0.5 7.83502 8.26485 0 17.8433 0C27.4217 0 35.1866 7.83502 35.1866 17.5Z" fill="#0088FF"/>
      <path d="M26 10H10C8.89 10 8.01 10.89 8.01 12L8 24C8 25.11 8.89 26 10 26H26C27.11 26 28 25.11 28 24V12C28 10.89 27.11 10 26 10ZM26 24H10V18H26V24ZM26 14H10V12H26V14Z" fill="white"/>
  </svg>
  `;

  return <SvgXml xml={xml} {...{width}} />;
};
